import React, { useState } from "react";
import { photos } from "./photos";

function PhotoSection() {
  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openModal = (index) => {
    setCurrentIndex(index);
    setIsOpen(true);
  };

  const closeModal = () => setIsOpen(false);

  const showPrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? photos.length - 1 : prev - 1));
  };

  const showNext = () => {
    setCurrentIndex((prev) => (prev === photos.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className="bg-[#eaebec] pt-10 pb-20 w-full">
      {/* Section Header */}
      <div className="flex items-center justify-center mb-8">
        <div className="text-center">
          <h2 className="text-2xl md:text-3xl font-semibold my-2">Gallery</h2>
          <div className="border-b-4 border-green-600 w-20 mx-auto" />
        </div>
      </div>

      {/* Grid Content */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 w-full max-w-[1280px] mx-auto px-4 2xl:px-0">
        {photos.map((photo, index) => (
          <div
            key={index}
            className="w-full h-[235px] cursor-pointer"
            onClick={() => openModal(index)}
          >
            <img
              src={photo.src}
              alt={photo.alt}
              className="w-full h-full object-cover p-2 bg-azure"
            />
          </div>
        ))}
      </div>

      {/* Modal Lightbox */}
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50">
          {/* Close Button */}
          <button
            onClick={closeModal}
            className="absolute top-6 right-6 text-white text-3xl font-bold"
          >
            ✕
          </button>

          {/* Prev Button */}
          <button
            onClick={showPrev}
            className="absolute left-6 text-white text-4xl font-bold px-3 py-1 rounded-full  hover:text-black"
          >
            ‹
          </button>

          {/* Next Button */}
          <button
            onClick={showNext}
            className="absolute right-6 text-white text-4xl font-bold px-3 py-1 rounded-full hover:bg-white hover:text-black"
          >
            ›
          </button>

          {/* Image */}
          <img
            src={photos[currentIndex].src}
            alt={photos[currentIndex].alt}
            className="max-h-[80vh] max-w-[90vw] object-contain rounded-lg shadow-lg"
          />
        </div>
      )}
    </div>
  );
}

export default PhotoSection;
